import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyAuditRoute = lazy(() => retry(() => import('app/pages/admin/Audit')));
const LazyBankAccountReviewIndexRoute = lazy(() =>
  retry(() => import('app/pages/admin/Dashboard/BankAccountReview/Index')));
const LazyBankAccountReviewShowRoute = lazy(() =>
  retry(() => import('app/pages/admin/Dashboard/BankAccountReview/Show')));
const LazyDashboardRoute = lazy(() => retry(() => import('app/pages/admin/Dashboard')));
const LazyInvoicesRoute = lazy(() => retry(() => import('app/pages/admin/Dashboard/Invoices')));
const LazyMetricsRoute = lazy(() => retry(() => import('app/pages/admin/Metrics')));
const LazyMetricHistoryRoute = lazy(() => retry(() => import('app/pages/admin/Metrics/metricHistory')));

export const Audit = (props: ComponentProps) => <LazyAuditRoute {...props} />;
export const BankAccountReviewIndex = (props: ComponentProps) => <LazyBankAccountReviewIndexRoute {...props} />;
export const BankAccountReviewShow = (props: ComponentProps) => <LazyBankAccountReviewShowRoute {...props} />;
export const Dashboard = (props: ComponentProps) => <LazyDashboardRoute {...props} />;
export const Invoices = (props: ComponentProps) => <LazyInvoicesRoute {...props} />;
export const Metrics = (props: ComponentProps) => <LazyMetricsRoute {...props} />;
export const MetricHistory = (props: ComponentProps) => <LazyMetricHistoryRoute {...props} />;
